@import (reference) '../../components/app-header/app-header.module.less';
@import (reference) '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';
@import (reference) 'ui-components/components/button/button-text.module.less';

.order-details-drawer {
  overflow: hidden;
  height: 100%;
  background: @order-details--default--background-color;
}

.order-details-drawer-body {
  height: 100%;
  flex: 1;
  overflow: hidden;
}

.order-details-sidebar-and-selected-content-container {
  display: flex;
  overflow: hidden;
  flex: 1;
}

.order-number {
  color: @order-details-canvas--order-number-header--text-color;
  margin-right: @space-16;
}

.tabbable {
  &:focus-visible {
    background-color: var(--order-details-canvas--header-buttons--focus--background-color);
    outline: 1px solid var(--tabs--tab-button--hover--text-color);
    border-radius: 4px;
    box-shadow: 0 0 4px var(--tabs--tab-button--hover--text-color);

    &.header-button {
      svg,
      .button-name,
      .button-name .caret > svg {
        color: var(--order-details-canvas--header-buttons--focus--text-color);
      }
    }
  }
}

.override-existing-toggler > div[class^='dropdown-toggler-content'] {
  overflow: visible;
  // ^ overrides the 'overflow:hidden' in the div.dropdown-toggler-content
  // that wraps our .tabbable header button. we do this so that our
  // .tabbable:focus-visible outline will be displayed to the user
}

.demo-banner {
  background-color: var(--green-22EE88);
  color: var(--grey-900);
  margin-bottom: @space-16;
  justify-content: center;
  padding: @space-12;
}

.order-details-content-wrapper {
  flex: 1;
}
.show-list-button {
  border-radius: 5px;
  border: 1px solid var(--gray-AFB3B6);
}
